"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamById = exports.getTeams = exports.getTeamsMap = exports.getTeamsIds = exports.getIsTeamsIdle = exports.getIsTeamsLoaded = exports.getIsTeamsLoading = exports.getTeamsStatus = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _teams = require("./teams.reducer");

var getTeamsState = function getTeamsState(state) {
  return state.modules.campaignSettings.entities.teams;
};

var selectors = _teams.teamsAdapter.getSelectors(getTeamsState);

var getTeamsStatus = (0, _ramda.pipe)(getTeamsState, (0, _ramda.prop)('status'));
exports.getTeamsStatus = getTeamsStatus;
var getIsTeamsLoading = (0, _ramda.pipe)(getTeamsState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsTeamsLoading = getIsTeamsLoading;
var getIsTeamsLoaded = (0, _ramda.pipe)(getTeamsState, function (state) {
  return state.status === _utils.StateStatus.Fulfilled;
});
exports.getIsTeamsLoaded = getIsTeamsLoaded;
var getIsTeamsIdle = (0, _ramda.pipe)(getTeamsState, function (state) {
  return state.status === _utils.StateStatus.Idle;
});
exports.getIsTeamsIdle = getIsTeamsIdle;
var getTeamsIds = selectors.getIds;
exports.getTeamsIds = getTeamsIds;
var getTeamsMap = selectors.getEntities;
exports.getTeamsMap = getTeamsMap;
var getTeams = selectors.getAll;
exports.getTeams = getTeams;
var getTeamById = selectors.getById;
exports.getTeamById = getTeamById;